import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDzX2PcirVBWxDcMZ5Bk6i0LdRFDq5YkwY",
  authDomain: "tavag-fa867.firebaseapp.com",
  projectId: "tavag-fa867",
  storageBucket: "tavag-fa867.appspot.com",
  messagingSenderId: "543702286315",
  appId: "1:543702286315:web:9f3c21d1be3ea9e3941397"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Set persistence to LOCAL so user stays logged in after refresh
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('✅ Firebase persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('❌ Firebase persistence error:', error);
  });

export { auth };
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;


